











































import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import WithAuthUser from "@/mixins/WithAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { getMainCurrencyCode, formatMoneyString } from "@/lib/moneyHelpers";
import config from "@/config";
import { BlockingStatus } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIconButton from "@/components/BaseIconButton";
import LinkifiedText from "@/components/LinkifiedText";
import MessageItemAttachment from "./MessageItemAttachment.vue";
import PurchaseConfirmation from "./PurchaseConfirmation.vue";
import MessageItemLink from "../../components/MessageItemLink";
import MessageView from "../../mixins/MessageView";

@Component({
  name: "MessageItemView",
  components: {
    MessageItemLink,
    PurchaseConfirmation,
    BaseConfirm,
    BaseButton,
    BaseIconButton,
    MessageItemAttachment,
    LinkifiedText,
  },
})
export default class MessageItemView extends mixins(MessageView, WithAuthUser) {
  public showUnlock: boolean = false;

  @Prop({ required: true, type: Array })
  public readonly paymentPackages!: PaymentPackage[];

  @Prop({ type: String, required: true })
  public userId!: string;

  @Prop({ type: String, required: true })
  public authUserId!: string;

  @Prop({ type: Object, required: true })
  public blockingStatus!: BlockingStatus;

  public get isAuthor() {
    return this.message.senderId === this.authUserId;
  }

  public get renderMessageMenu() {
    return this.opponentMessage
      ? checkAuthorities(this.authUserAuthorities, ["deleteAnyMessage"])
      : checkAuthorities(this.authUserAuthorities, ["deleteMyMessage"]) &&
          !this.message.attachmentPurchasers?.includes(this.userId);
  }

  public get available() {
    if (!this.isAuthor) {
      return this.message.attachmentAvailable ?? false;
    }
    const purchased = !!this.message.attachmentPurchasers?.find(id => id === this.userId);
    return !this.hasPrice || purchased;
  }

  public get price() {
    return formatMoneyString(
      this.paymentPackages
        .find(pkg => pkg.id === this.message.attachmentPricePackageId)
        ?.costs.find(cost => cost.currency === getMainCurrencyCode())?.cost || 0,
      { currencyCode: getMainCurrencyCode() }
    );
  }

  public get purchasedStatText() {
    return this.available ? $t("Purchased for {0}", [this.price]) : $t("Not purchased yet");
  }

  public get hasPrice() {
    return this.message.attachmentPricePackageId !== "0";
  }

  public get linksValidation() {
    return config.featureClickableUserLinks && !!(this.message?.senderUser as UserPublicData)?.verified;
  }

  public get isAllowExternalLinks() {
    return config.featureClickableUserExternalLinks;
  }

  public async attachmentClick() {
    if (this.available || this.isAuthor || this.blockingStatus.authUser) return;
    this.showUnlock = true;
  }
}
